export default __webpack_public_path__ + "static/media/defaultappicon.497d1758.png";